/* eslint global-require: 0 */
import { browserHistory } from 'react-router';
import { apiUrl, useSSO } from 'config';
import * as types from 'constants/ActionTypes';
import axios from 'axios';
import { get } from 'lodash';
import { read } from 'utils/Api';
import { fetchOrgsIfNeeded } from '../profile';
import { custom } from '../../utils/Api';

function loginRequest(credentials) {
  return {
    type: types.LOGIN_REQUEST,
    credentials,
  };
}

function loginFailure(error) {
  return {
    type: types.LOGIN_FAILURE,
    error,
  };
}

function loginSuccess(user) {

  return {
    type: types.LOGIN_SUCCESS,
    user,
  };
}
function setSecurityCode(securityCode) {
  return {
    type: types.SET_SECURITY_CODE,
    securityCode,
  };
}

export function loginStep(step) {
  return {
    type: types.LOGIN_STEP,
    step,
  };
}

export function loginValidationErrors(validationError) {
  return {
    type: types.LOGIN_VALIDATION_ERRORS,
    validationError,
  };
}

export function ssoCheckStart() {
  return {
    type: types.SSO_CHECK_START,
  };
}

export function ssoCheckEnd({ error, data }) {
  return {
    type: types.SSO_CHECK_END,
    error,
    data,
  };
}

function fetchEmployeeMasterID(user, ssoCheck) {
  return (dispatch, getState) => {
    const fetchConfig = {
      url: '/kjarni/api/v2/EmployeeXapUsers/MyUserInfo',
    };

    custom(fetchConfig)
      .then((data) => {
        const e = get(data, 'data');
        if (!e || !e.EmployeeMasterID) {
          dispatch(loginFailure({ Message: 'Kjarna notandi ekki rétt tengdur' }));
        } else {
          read({
            entity: 'EmployeeMaster',
            entityID: e.EmployeeMasterID,
            headers: { Authorization: `Bearer ${user.token}` },
          }).then((empMaster) => {
            const Gender = `${empMaster.data.GenderType}`;
            localStorage.EmployeeMasterID = e.EmployeeMasterID;
            localStorage.DefaultEmployeeDetailID = empMaster.data.DefaultEmployeeDetailID;
            localStorage.EmployeeName = e.EmployeeName;
            localStorage.Email = e.EmailWork || e.Email;
            localStorage.Gender = Gender;
            dispatch(loginSuccess({
              ...user,
              ...e,
              UserName: e.XapUserName,
              EmployeeMasterID: e.EmployeeMasterID,
              Gender,
              DefaultEmployeeDetailID: empMaster.data.DefaultEmployeeDetailID,
            }));
            dispatch(fetchOrgsIfNeeded());
            ssoCheck && dispatch(ssoCheckEnd({ data: user }));
            /* Route the user to the page he tried to access before logging in */
            if (!useSSO) {
              const { routing: { locationBeforeTransitions: { state } } } = getState();
              const loginRoute = (state && state.nextPathname) ? state.nextPathname : '/';
              browserHistory.replace(loginRoute);
            }
          }).catch(error => dispatch(loginFailure({ ...error, Message: error.message })));
        }
      }).catch(error => dispatch(loginFailure({ ...error, Message: error.message, myUserInfo: true })));
  };
}

export function loginUser(username, password) {
  if (!username) {
    const error = { Message: 'Vinsamlegast skráið notandanafn' };
    return dispatch => dispatch(loginValidationErrors(error));
  }
  if (!password) {
    const error = { Message: 'Vinsamlegast skráið lykilorð' };
    return dispatch => dispatch(loginValidationErrors(error));
  }

  const config = {
    method: 'POST',
    url: `${apiUrl}/Token`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: `grant_type=password&username=${username}&password=${password}`,
  };

  return (dispatch) => {

    dispatch(loginRequest({ username, password }));
    return axios(config)
      .then(({ data }) => {
        localStorage.token = data.access_token;
        localStorage.refreshToken = data.refresh_token;
        localStorage.userName = data.userName;
        localStorage.sso = false;
        localStorage.expires = Date.now() + (1000 * data.expires_in);

        const user = {
          userName: data.userName,
          token: data.access_token,
        };

        dispatch(fetchEmployeeMasterID(user));

      })
      .catch((error) => {
        if (error.response) {
          dispatch(loginFailure({ Message: error.response.data.error_description || error.response.data.error_description }));
        } else {
          dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
        }
      });
  };
}

export function twoFactorLogin(value, app = false) {
  if (app && value.length !== 10) {
    const error = { Message: 'auth.error.ssn.length' };
    return dispatch => dispatch(loginValidationErrors(error));
  } else if (!app && value.length !== 7) {
    const error = { Message: 'auth.error.mobile.length' };
    return dispatch => dispatch(loginValidationErrors(error));
  }
  const url = app ? `${apiUrl}/api/Account/SsnLogin?provider=inngangur&identifier=${value}` : `${apiUrl}/api/Account/MobileLogin?provider=inngangur&identifier=${value}`;
  const twoFactorAuthConfig = {
    method: 'GET',
    url,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };
  return (dispatch) => {
    dispatch(loginRequest({ value }));
    axios(twoFactorAuthConfig)
      .then(async (result) => {
        const { verificationCode, authId } = get(result, 'data');
        dispatch(setSecurityCode(verificationCode));
        const twoFactorTokenConfig = {
          method: 'POST',
          url: `${apiUrl}/Token`,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: `auth_id=${authId}&grant_type=inngangur`,
        };
        try {
          const { data } = await axios(twoFactorTokenConfig);
          localStorage.token = data.access_token;
          localStorage.refreshToken = data.refresh_token;
          localStorage.userName = data.userName;
          localStorage.sso = false;
          localStorage.expires = Date.now() + (1000 * data.expires_in);

          const user = {
            userName: data.userName,
            token: data.access_token,
          };

          dispatch(fetchEmployeeMasterID(user));
        } catch (error) {
          if (error.response) {
            dispatch(loginFailure({ Message: error.response.data.error_description || error.response.data.error_description }));
          } else {
            dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
          }
        }
      }).catch((error) => {
        if (error.response) {
          dispatch(loginFailure({ Message: error.response.data.error_description || error.response.data.error_description }));
        } else {
          dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
        }
      });
  };
}


export function sso() {
  return (dispatch) => {
    dispatch(ssoCheckStart());
    const config = {
      url: `${apiUrl}/api/qdata/PrincipalUser`,
    };
    custom(config)
      .then((res) => {
        const userName = res.data;
        localStorage.userName = userName;
        localStorage.sso = true;
        dispatch(fetchEmployeeMasterID({ userName, sso: true }, true));
      })
      .catch((error) => {
        dispatch(ssoCheckEnd({ error }));
        dispatch(loginStep('sso'));
      });
  };
}

export function notAuthenticated() {
  return {
    type: types.NOT_AUTHENTICATED,
  };
}

export function authenticated(user) {
  return {
    type: types.AUTHENTICATED,
    user,
  };
}



// WEBPACK FOOTER //
// ./src/actions/account/login.js